module.exports = "/assets/packs/images/9e4ca84219b935c5ff6a704c754e4509.png";